import "./index.css";

import { useEffect } from "react";

import { ApolloProvider } from "@apollo/client/react";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { store } from "@/app/store";
import {
  getAuthorizationToken,
  removeAuthorizationToken,
  setAuthorizationCookie,
  setAuthorizationToken,
} from "@/authorizationToken";
import { clearSession, setSession } from "@/features/sessionSlice";
import { RefreshDocument } from "@/gql/graphql";
import AppRoutes from "@/routes/AppRoutes";

import client from "./apolloClient";

function Root() {
  useEffect(() => {
    const token = getAuthorizationToken();

    if (token) {
      client
        .mutate({ mutation: RefreshDocument })
        .then(({ data }) => {
          if (!data?.refresh) return;

          setAuthorizationToken(data.refresh.token);
          setAuthorizationCookie(token);

          store.dispatch(
            setSession({
              user: data.refresh.user,
              customer: { ...data.refresh.customer, attrs: data.refresh.customer.attrs as CustomerAttrsType },
              token: data.refresh.token,
              loading: false,
            }),
          );
        })
        .catch(() => {
          removeAuthorizationToken();
          store.dispatch(clearSession());
        });
    } else {
      store.dispatch(clearSession());
    }
  }, []);

  return <AppRoutes />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <Root />
    </ApolloProvider>
  </Provider>,
);

Sentry.init({
  dsn: "https://ea9857a41ee5c94f8a70159c67491a05@o254619.ingest.us.sentry.io/4510025052520448",
  integrations: [Sentry.browserTracingIntegration()],
  enabled: process.env.NODE_ENV === "production",
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0,
  release: import.meta.env.VITE_VERSION,
  environment: process.env.NODE_ENV,
});
